module.exports = __webpack_public_path__ + "img/microphone.215cbe24.png";